import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { resolve } from 'dns';
import FingerprintJS2 from 'fingerprintjs2';
import { BrowserInfoDT } from 'services/apis/sys/user-api';

export const getBrowserFinger = (): Promise<BrowserInfoDT> => {
  return new Promise(async (resolve) => {
    // fingerprintjs不稳定因素太多了
    // https://github.com/fingerprintjs/fingerprintjs/blob/HEAD/docs/api.md
    // const result = await (await FingerprintJS.load({ debug: false })).get();
    // // 析构 components 排除不稳定因素获取 扩展库
    // const { ...components } = result.components;
    // // 使用 components 重新计算 visitorId
    // const visitorId = await FingerprintJS.hashComponents(components);
    // console.log('FingerprintJS-result', result);
    // console.log('FingerprintJS-hash', visitorId);

    // fingerprintjs2已过时？
    FingerprintJS2.get((components) => {
      const values = components.map((component) => component.value);
      const fingerprint = FingerprintJS2.x64hash128(values.join(''), 31);

      const browserFingerprint: BrowserInfoDT = {
        fingerprint,
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        screenResolution: `${window.screen.width}x${window.screen.height}`,
        colorDepth: window.screen.colorDepth,
      };

      resolve(browserFingerprint);
    });
  });
};
